import React from "react";
import styles from "./Loader.module.css";

interface LoaderProps {
  text?: string;
}

const Loader: React.FC<LoaderProps> = ({ text }) => {
  return (
    <div className={styles.loaderWrapper}>
      {text ? (
        <div className={styles.loaderPopup}>
          <div className={styles.loaderPopupContainer}>
            <div className={styles.loader}></div>
            <p>{text}</p>
          </div>
        </div>
      ) : (
        <div className={styles.loader}></div>
      )}
    </div>
  );
};

export default Loader;
